import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { StatComponent } from './stat.component';

@NgModule({
  declarations: [StatComponent],
  exports: [StatComponent],
  imports: [CommonModule, TranslateModule],
})
export class StatModule {}
